import type { Catalog } from '../types';

export const nav = {
  'nav.timeline': { pt: 'Timeline', en: 'Timeline' },
  'nav.rounds': { pt: 'Voltas', en: 'Rounds' },
  'nav.record': { pt: 'Registrar', en: 'Record' },
  'nav.recordLong': { pt: 'Registrar volta', en: 'Record round' },
  'nav.stats': { pt: 'Stats', en: 'Stats' },
  'nav.courses': { pt: 'Campos', en: 'Courses' },

  'nav.skipToContent': { pt: 'Pular para o conteúdo', en: 'Skip to content' },

  'nav.aria.main': { pt: 'Principal', en: 'Main' },
  'nav.aria.home': { pt: 'PinTrack — início', en: 'PinTrack — home' },
  'nav.aria.profile': { pt: 'Seu perfil', en: 'Your profile' },
} as const satisfies Catalog;
